import { Stack, StackItem, TextField } from '@fluentui/react';
import { observer } from 'mobx-react';
import { ProvisionProfileEditorState } from './ProvisionProfileEditor';

import { InfoTooltipLabel } from '../../controls/InfoTooltipLabel';
import ExpressionField from '../expression-builder/ExpressionField';

function ProfileNameAndCondition({ state }: { state: ProvisionProfileEditorState }) {
	
	return (<>
			<Stack>
				<StackItem>

					<InfoTooltipLabel label='Profile name' 
						title='The profile name can be specified during provision requests to force this profile to be used.'>
						<TextField defaultValue={state.Name} onChange={(e, v) => { state.setName(v || '');  }} />
					</InfoTooltipLabel>
				</StackItem>

				<StackItem>
					<InfoTooltipLabel label='Profile condition' title='Enter an expression to determine whether this profile will be used. The first matching profile to match a condition is used.'>
						<ExpressionField state={state.expressionState} />
					</InfoTooltipLabel>
				</StackItem>
			</Stack>
		</>
	);
}

export default observer(ProfileNameAndCondition);
